import React from 'react';
import { useLocalization } from '../../context/Localization/localization';
import { Heading, IHeadingProps } from '../Heading/Heading';
import css from './KeyManagementHeader.module.scss';
import { GMRoundedIcon, GMSizedIcon } from '../Icon';

interface IProps extends Omit<IHeadingProps, 'primaryHeading' | 'roundedIcon'> {
    leftAlignSecondaryHeading?: boolean;
    addKey?: boolean;
    primaryHeading?: string;
}

// TODO: This is re-used in almost every component. Investigate commonizing the redundant code into a single key management wrapper component.
export const KeyManagementHeader: React.FC<IProps> = ({ leftAlignSecondaryHeading, addKey, secondaryHeading, primaryHeading, ...headingProps }) => {
    const Localization = useLocalization();

    return (
        <Heading
            primaryHeading={primaryHeading ? primaryHeading : addKey ? Localization.AddKey : Localization.KeyManagement}
            roundedIcon={
                <GMRoundedIcon roundedBackgroundSize={'large'} themeType={'secondary'}>
                    <GMSizedIcon iconType={'Key'} iconSize={'large'} />
                </GMRoundedIcon>
            }
            secondaryHeading={secondaryHeading && <div className={leftAlignSecondaryHeading ? css.leftAlign : undefined}>{secondaryHeading}</div>}
            {...headingProps}
        />
    );
};
